/**
 * Routes a signed-out visitor is supposed to be on. Two things key off this:
 * the session probe never gates rendering here, and a 401 here is nobody's
 * business (no redirect, no "session expired") — it is just the probe finding
 * no session, which is the expected state of these pages.
 *
 * One list on purpose. It used to live in two places that drifted: the axios
 * copy lacked /token/, so the probe's 401 on the invitation page bounced the
 * invitee to /login before they could set a password.
 */
export const PUBLIC_AUTH_PATH_PREFIXES = ['/verify-email/', '/reset-password/', '/token/'] as const;
export const PUBLIC_AUTH_PATHS = ['/login', '/register', '/forgot-password'] as const;

export function isPublicAuthPath(pathname: string): boolean {
  return (
    (PUBLIC_AUTH_PATHS as readonly string[]).includes(pathname) ||
    PUBLIC_AUTH_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}
